import { StoreState } from '@/redux/types';

export const getProductTypeDiscounts = (state: StoreState, productTypeId: string) =>
  state.discounts.productType[productTypeId];
